import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles.js';

const OrdersPage = lazy(() => import('./OrdersPage'));

const OrdersConfig = {
  auth: AuthRoles.Orders,
  routes: [
    {
      path: 'orders',
      element: <OrdersPage />,
    },
  ],
};

export default OrdersConfig;
